import { render } from "./TitleFunction.vue?vue&type=template&id=4deddb35"
import script from "./TitleFunction.vue?vue&type=script&lang=js"
export * from "./TitleFunction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__